<template lang="pug">
.card
    .card-image
        figure.image.is-4by3
            img.rounded-corners(src="@/assets/weather/rain-night.jpeg")
    .card-content
        .media
            .media-left
                figure.image.is-48x48
                    img(src="@/assets/symbols/sun.max.png")
            .media-content
                p.title.is-5.has-text-weight-medium Rain
                p.subtitle.is-6.has-text-weight-light Low: 42, High: 56
</template>

<script>
export default {
  name: "Weather"
};
</script>
